
import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import Breadcrumb from "./Breadcrumb/index.vue";
import Hamburger from "./Hamburger/index.vue";
import Screenfull from "@/components/screen-full/index.vue";
import SizeSelect from "@/components/SizeSelect/index.vue";
import { SettingsModule } from "@/store/modules/settings";
import Password from "@/components/Dialog/password.vue";
import MessageCenter from "./message.vue";
import EditInfo from "@/components/Dialog/editUserInfo.vue";
import checkDialog from '@/components/Dialog/checkDialog.vue'

@Component({
    name: "Navbar",
    components: {
        Breadcrumb,
        Hamburger,
        Screenfull,
        SizeSelect,
        Password,
        MessageCenter,
        EditInfo,
        checkDialog
    },
})
export default class extends Vue {
    private setShow: boolean = false;
    private operate: any = {
        pwdShow: false,
        msgShow: false,
        checkShow:false
    };

    get sidebar() {
        return AppModule.sidebar;
    }

    get device() {
        return AppModule.device.toString();
    }

    get name() {
        return UserModule.name;
    }

    get avatar() {
        return UserModule.avatar;
    }

    get qq() {
        return UserModule.qq;
    }

    get email() {
        return UserModule.email;
    }

    get phone() {
        return UserModule.phone;
    }

    get showSidebarTheme() {
        return SettingsModule.showSidebarTheme;
    }

    get info() {
        return UserModule.mainInfo;
    }

    get notice() {
        return UserModule.notice;
    }

    private toggleSideBar() {
        AppModule.ToggleSideBar(false);
    }

    private async logout() {
        await UserModule.LogOut();
        window.location.href = `/login?redirect=${this.$route.fullPath}`;
    }
}
